import View from './new-request-view';

export default View;
